import { supabase } from "../lib/supabase";

// Module-level cache: the curated platform list rarely changes, and both
// BillingMethodSection and UserMenu's Affiliate Platform Reporting card
// fetch it independently — without this, opening both in one session hits
// the Edge Function (and its external DB query) twice for identical data.
// Caching the in-flight promise (not just the resolved value) also
// collapses concurrent callers into a single network round-trip.
let cachedPlatformsPromise = null;

export async function fetchAffiliatePlatforms() {
  if (!supabase) return [];
  if (!cachedPlatformsPromise) {
    cachedPlatformsPromise = supabase.functions.invoke("affiliate-platforms")
      .then(({ data, error }) => {
        if (error) throw error;
        return data?.platforms ?? [];
      })
      .catch((err) => {
        cachedPlatformsPromise = null; // don't cache failures — let the next call retry
        throw err;
      });
  }
  return cachedPlatformsPromise;
}

// Test-only escape hatch — the module-level cache persists across test
// cases within the same file unless explicitly cleared.
export function __resetAffiliatePlatformsCacheForTests() {
  cachedPlatformsPromise = null;
}
